
import { defineComponent, PropType } from "vue";

import { NFormItem, NInputNumber } from "naive-ui";

import { useModelValue } from "@/composables/use-model-value";

import { Attribute } from "@/models/tile.model";

export default defineComponent({
  name: "InputNumberElement",

  props: {
    modelValue: Number,

    attribute: {
      type: Object as PropType<Attribute>,
      required: true,
    },
  },

  components: {
    NFormItem,
    NInputNumber,
  },

  setup(props, context) {
    const localValue = useModelValue(props, context.emit);

    return {
      localValue,
    };
  },
});
